// src/components/Snackbar.jsx
import React, { useEffect, useState, memo } from "react";

const snackbarStyles = {
  container: {
    position: "fixed",
    bottom: "20px",
    left: "50%",
    transform: "translateX(-50%)",
    backgroundColor: "#323232",
    color: "#f1f1f1",
    padding: "14px 24px",
    borderRadius: "8px",
    boxShadow:
      "0 3px 5px -1px rgba(0,0,0,.2), 0 6px 10px 0 rgba(0,0,0,.14), 0 1px 18px 0 rgba(0,0,0,.12)",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    zIndex: 9999,
    minWidth: "344px",
    maxWidth: "568px",
    transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
  },
  messageRow: {
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  message: {
    flexGrow: 1,
    marginRight: "16px",
    fontSize: "0.9rem",
  },
  closeButton: {
    cursor: "pointer",
    backgroundColor: "transparent",
    border: "none",
    color: "#f1f1f1",
    fontSize: "1.2rem",
    lineHeight: 1,
  },
  progressBarContainer: {
    width: "100%",
    height: "4px",
    backgroundColor: "rgba(255, 255, 255, 0.2)",
    borderRadius: "2px",
    marginTop: "8px",
    overflow: "hidden",
  },
  progressBar: {
    height: "100%",
    backgroundColor: "#00e676",
    transition: "width 0.05s linear",
  },
};

function Snackbar({ message, open, onClose, duration = 3000 }) {
  const [progress, setProgress] = useState(100);

  useEffect(() => {
    if (open) {
      setProgress(100);

      const interval = 50;
      const step = (interval / duration) * 100;

      const timer = setTimeout(onClose, duration);
      const progressInterval = setInterval(() => {
        setProgress((prev) => Math.max(0, prev - step));
      }, interval);

      return () => {
        clearTimeout(timer);
        clearInterval(progressInterval);
      };
    }
  }, [open, duration, onClose]);

  if (!open) {
    return null;
  }

  return (
    <div style={snackbarStyles.container}>
      <div style={snackbarStyles.messageRow}>
        <span style={snackbarStyles.message}>{message}</span>
        <button onClick={onClose} style={snackbarStyles.closeButton}>
          &times;
        </button>
      </div>
      <div style={snackbarStyles.progressBarContainer}>
        <div
          style={{
            ...snackbarStyles.progressBar,
            width: `${progress}%`,
          }}
        />
      </div>
    </div>
  );
}

export default memo(Snackbar, (prevProps, nextProps) => {
  return (
    prevProps.message === nextProps.message &&
    prevProps.open === nextProps.open &&
    prevProps.duration === nextProps.duration
  );
});
